import { ImageEditor } from "./lib/editor";
import type { EditorConfig } from "./lib/editor";
import { EditorHeader } from "./lib/editor/components/EditorHeader";

const demoConfig: EditorConfig = {
  allowSave: false,
  allowExport: true,
  allowAdvancedFeatures: true,
  features: ["global-light", "regional-light", "color", "tonal-curve", "color-grading"],
};

export function App() {
  return (
    <div className="h-screen w-screen">
      <ImageEditor
        config={demoConfig}
        header={({ hasImage, onPreviewUpdate }) => (
          <EditorHeader hasImage={hasImage} onPreviewUpdate={onPreviewUpdate} />
        )}
      />
    </div>
  );
}
